<template>
  <v-container>
    <device
      v-if="choosenDeviceAlert==null && path=='info' && choosenDevice!=null"
      @backnetwork="$emit('backnetwork')"
      @createAlert="createAlert"
      @updateAlert="updateAlert"
      :device="choosenDevice"
    ></device>
    <createDevice
      @back="$emit('stopcreate')"
      :networkId="networkId"
      @save="newDeviceSaved"
      v-if="path=='create'"
    ></createDevice>
    <setalert
      v-if="choosenDeviceAlert!=null && choosenDevice!=null"
      :deviceAlert="choosenDeviceAlert"
      :choosenDevice="choosenDevice"
      :create="createAlertBool"
      @saved="alertSaved"
      @back="backDevice"
    ></setalert>
  </v-container>
</template>

<script>
import DeviceComponent from "../DataHome/ShowDevice";
import SetDeviceAlertComponent from "../DataHome/SetDeviceAlert";

export default {
  components: {
    device: DeviceComponent,
    setalert: SetDeviceAlertComponent,
  },
  props: {
    choosenDevice: Object,
    path: String,
    choosenDeviceAlert: Object,
  },
  data() {
    return {
      createAlertBool: null,
    };
  },
  methods: {
    updateAlert(alert) {
      this.createAlertBool = false;
      this.$emit("updateDeviceAlert", alert);
    },
    createAlert() {
      this.createAlertBool = true;
      this.$emit("createDeviceAlert");
    },
    backDevice: function () {
      this.$emit("backDevice");
    },
    alertSaved: function () {
      this.$emit("alertSaved");
    },
  },
};
</script>


